import React, { useEffect, useState } from "react";
// import { setLogFilters } from "../../config/logger/logger";
import { useIsFetching } from "@tanstack/react-query";

export const LOG_FILTER_OPTIONS = ["Axios", "Context"];
const DEFAULT_FILTERS = LOG_FILTER_OPTIONS.filter((opt) => opt !== "Axios");

const DevBanner = () => {
	const isFetching = useIsFetching();

	const [selected, setSelected] = useState(DEFAULT_FILTERS);

	const toggleFilter = (filter: any) => {
		const newFilters = selected.includes(filter) ? selected.filter((f) => f !== filter) : [...selected, filter];

		setSelected(newFilters);
		// setLogFilters(newFilters);

		// save filter to localStorage
		localStorage.setItem("logFilters", JSON.stringify(newFilters));
	};

	const [domainName, setDomainName] = useState<string>("");

	useEffect(() => {
		setDomainName(extractHostname(window.location.href));

		// load filters from localStorage
		const storedFilters = localStorage.getItem("logFilters");
		if (storedFilters) {
			const parsedFilters = JSON.parse(storedFilters);
			setSelected(parsedFilters);
			// setLogFilters(parsedFilters);
		} else {
			// setLogFilters(DEFAULT_FILTERS);
		}
	}, []);

	function extractHostname(url: string) {
		let hostname;
		//find & remove protocol (http, ftp, etc.) and get hostname

		if (url.indexOf("//") > -1) {
			hostname = url.split("/")[2];
		} else {
			hostname = url.split("/")[0];
		}

		//find & remove port number
		hostname = hostname.split(":")[0];
		//find & remove "?"
		hostname = hostname.split("?")[0];

		return hostname;
	}
 
	if (domainName && (domainName === "localhost" || domainName.includes("dev"))) {
		return (
			<div
				className="row"
				style={{
					// position: "fixed",
					zIndex: 999999999999,
					background: "#c0392b",
					color: "#fff",
					alignItems: "center",
					textAlign: "center",
					fontWeight: "bold",
					fontSize: 10,
					left: 0,
					right: 0,
				}}
			>
				<div className="position-relative">
					<div className="dropdown">
						<span
							className="dropdown-toggle"
							style={{ cursor: "pointer" }}
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							{isFetching > 0 ? <>Fetching...</> : <>Idle</>} -- Development Environment --
						</span>

						{(domainName === "localhost" || domainName.includes("dev")) && (
							<ul
								className="dropdown-menu show"
								style={{
									display: "none",
									position: "absolute",
									top: "100%",
									left: "50%",
									transform: "translateX(-50%)",
									backgroundColor: "#fff",
									color: "#000",
									border: "1px solid #ccc",
									minWidth: "200px",
									zIndex: 999999999999,
								}}
							>
								{LOG_FILTER_OPTIONS.map((filter) => (
									<li key={filter}>
										<button className={`dropdown-item`} onClick={() => toggleFilter(filter)}>
											<input
												type="checkbox"
												className="me-2"
												checked={selected.includes(filter)}
												readOnly
											/>
											{filter}
										</button>
									</li>
								))}
							</ul>
						)}
					</div>
				</div>

				{/* Custom hover logic with JS */}
				<style>
					{`
						.dropdown:hover .dropdown-menu {
							display: block !important;
						}
					`}
				</style>
			</div>
		);
	}

	return null;
};

export default DevBanner;
